module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/hero-223137faf87f78a627db7eb6add4f4ed.jpg";